import axios from 'axiosConfig';

export const deleteLoanType = (LoanTypeID) => axios.delete(`/api/loantype/deleteloantype/${LoanTypeID}`);
export const reactivateLoanType = (LoanTypeID) => axios.post(`/api/loantype/reactivateloantype/${LoanTypeID}`);

export const addLoanType = (newLoanType) => axios.post("/api/loantype/addloantype", newLoanType, {});

export const getAllLoanType = (userID) => axios.get("/api/loantype/getloantypes", {});

export const updateLoanType = (loanType) => axios.put("/api/loantype/updateloantype", loanType, {});

